export const spring = ({ initialTarget = 0, callbackFn }) => {
  const k = -20; // Stiffness
  const b = -2; // Damping
  const mass = 0.1;

  let accelerationX = 0;
  let velocityX = 0;
  let currentX = initialTarget;
  let targetX = initialTarget;
  let startTime;
  let running = true;

  function loop(timestamp) {
    if (!startTime) startTime = timestamp;
    const now = timestamp;
    let delta = now - startTime;

    if (delta > 60) delta = 60;

    startTime = now;

    var spring_x = k * (currentX - targetX);
    var damper_x = b * velocityX;
    accelerationX = (spring_x + damper_x) / mass;
    velocityX += accelerationX * (delta / 1000);
    currentX += velocityX * (delta / 1000);

    if (running) {
      callbackFn(currentX);
    }
    running ? requestAnimationFrame(loop) : null;
  }

  requestAnimationFrame(loop);

  return {
    target(target) {
      targetX = target;
    },
    destroy() {
      running = false;
    },
  };
};
